import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Body2 from '@joinforma/ui/components/Body2';
import Title2 from '@joinforma/ui/components/Title2';
import { ScreenWidth } from '@joinforma/ui/constants/breakpoints';

import { SettingsRoutes } from 'utils/routeGenerator';
import { EVENTS } from 'constants/events';
import { logEvent } from 'utils/amplitude';
import { logRudderstackEvent } from 'utils/rudderstack';

const InfoTextContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${ScreenWidth.MOBILE_PORTRAIT}) {
    display: block;
    margin-left: 14px;
  }
`;
const InfoText = styled(Title2)``;

const BankLink = styled(Link)`
  margin-left: 4px;
  color: ${({ theme }) => theme.colors.text.link};
`;

const BankLinkText = styled(Body2)`
  display: inline;
  color: ${({ theme }) => theme.colors.text.link};
`;

const handleClick = () => {
  const attributes = {
    banner_type: 'bank_account_link',
    banner_name: 'pending_funds_bank_acct_link',
    page_id: 'base_layout',
  };
  logEvent(EVENTS.BannerClicked, attributes);
  logRudderstackEvent(EVENTS.BannerClicked, attributes);
};

const SetupDirectDepositForReimbursementWarning = () => (
  <InfoTextContainer>
    <InfoText>You have reimbursements waiting!</InfoText>
    {` `}
    <Body2>
      Link a personal bank account to get reimbursed via direct deposit.
    </Body2>
    <BankLink to={SettingsRoutes.bankAccounts()} onClick={handleClick}>
      <BankLinkText>Link bank account</BankLinkText>
    </BankLink>
  </InfoTextContainer>
);

export default SetupDirectDepositForReimbursementWarning;
